<template>
    <p style="text-align: center;"><strong><span class="tyc-span">Sorteo&ldquo;San Valent&iacute;n Interseguro
                2024&rdquo;</span></strong></p>
    <ol>
        <li><strong>
                <p class="tyc-p"><span class="tyc-title-span">Alcance</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <p class="tyc-p"><span class="tyc-title-span">Ser&aacute; materia de la
            presente Promoci&oacute;n Comercial el realizar un sorteo de ocho (08) vales AGORA para cuatro (04) ganadores, a
            raz&oacute;n de un vale por persona, entre todos los clientes que efect&uacute;en una compra de cualquiera de
            los siguientes productos digitales que ofrece Interseguro Compa&ntilde;&iacute;a de Seguros S.A. (en adelante,
            Interseguro):&nbsp;</span><strong><span class="tyc-title-span">SOAT, Seguro de Viajes,
                Vida Cash y Rumbo</span></strong><span class="tyc-title-span">; haciendo uso de la
            p&aacute;gina Web, ya sea accediendo directamente o a trav&eacute;s de nuestros anuncios publicitarios. Los
            participantes deben cumplir con todos los requisitos establecidos en los presentes t&eacute;rminos y
            condiciones, los cuales declaran haber le&iacute;do, conocer y aceptar en su totalidad.</span></p>
    <p><br></p>
    <p class="tyc-p"><span class="tyc-span">Esta promoci&oacute;n&nbsp;</span><u><span class="tyc-span">no
                aplica para otros canales de venta</span></u><span class="tyc-span">, ni
            es acumulable con otras promociones o descuentos.</span></p>
    <p class="tyc-p"><br></p>
    <ol start="2">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Beneficios del sorteo</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <p class="tyc-p"><span class="tyc-span">Sorteo de ocho (08) vales AGORA de S/100.00 (Cien y 00/100
            soles) para compras o pago de servicios. Participan del sorteo todas las personas que adquieran una nueva
            p&oacute;liza, durante las fechas definidas en el punto 4, de cualquiera de nuestros seguros
            digitales:&nbsp;</span><strong><span class="tyc-title-span">SOAT, Seguro de Viaje,
                Vida Cash y Rumbo&nbsp;</span></strong><span class="tyc-span">&nbsp;</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><br></p>
    <ul>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><strong><span class="tyc-title-span">Vida
                        Cash:</span></strong><span class="tyc-title-span">&nbsp;</span></p>
        </li>
    </ul>
    <p class="tyc-p"><span class="tyc-title-span">Participan los nuevos planes
            contratados bajo cualquier frecuencia de pago.&nbsp;</span><strong><span class="tyc-title-span">Aplica
                &uacute;nicamente para nuevas p&oacute;lizas
                contratadas, con coberturas mayores a S/ 100,000.00</span></strong><span class="tyc-title-span">&nbsp;y con
            porcentaje de&nbsp;</span><strong><span class="tyc-title-span">devoluci&oacute;n a partir del
                100%</span></strong><span class="tyc-title-span">. Participan los siguientes subproductos: Endoso con
            Devoluci&oacute;n, Seguro Vida con Devoluci&oacute;n, Ahorro Seguro, Ahorro Jubilaci&oacute;n, Seguro
            Universitario.&nbsp;</span><strong><span class="tyc-title-span">Aplica
                &uacute;nicamente para compras de nuevas p&oacute;lizas realizadas desde la p&aacute;gina web de
                Interseguro&nbsp;</span></strong><strong><span class="tyc-span">o desde la central de telemarketing
                Vida Interseguro</span></strong><span class="tyc-title-span">&nbsp;</span></p>
    <p><br></p>
    <ul>
        <li><strong>

                <p class="tyc-p"><span class="tyc-title-span">SOAT:</span>
                </p>

            </strong></li>
    </ul>
    <p class="tyc-p"><strong><span class="tyc-title-span">Aplica &uacute;nicamente
                para nuevas compras realizadas a trav&eacute;s de la p&aacute;gina web de Interseguro</span></strong><span
            class="tyc-title-span">&nbsp;durante las fechas de vigencia de esta
            campa&ntilde;a.</span></p>
    <p><br></p>
    <ul>
        <li><strong>

                <p class="tyc-p"><span class="tyc-title-span">Seguro de
                        Viajes:</span></p>

            </strong></li>
    </ul>
    <p class="tyc-p"><strong><span class="tyc-title-span">Aplica &uacute;nicamente
                para compras realizadas desde la p&aacute;gina web de Interseguro&nbsp;</span></strong><span
            class="tyc-title-span">durante las fechas de vigencia de esta campa&ntilde;a.</span>
    </p>
    <p><br></p>
    <ul>
        <li><strong>

                <p class="tyc-p"><span class="tyc-title-span">Rumbo:</span>
                </p>

            </strong></li>
    </ul>
    <p class="tyc-p"><strong><span class="tyc-title-span">Aplica &uacute;nicamente
                para compras de nuevas p&oacute;lizas realizadas desde la p&aacute;gina web de
                Interseguro&nbsp;</span></strong><strong><span class="tyc-span">o desde la central de telemarketing
                Rumbo Interseguro</span></strong><span class="tyc-title-span">&nbsp;durante las
            fechas de vigencia de esta campa&ntilde;a.</span></p>
    <p><br></p>
    <p class="tyc-p"><br></p>
    <ol start="3">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Premios materia del sorteo</span></p>
            </strong></li>
    </ol>
    <ul>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Ocho (08) tarjetas virtuales de AGORA por un valor
                    de S/ 100.00 (cien &nbsp;00/100 soles), que pueden ser empleadas para los fines establecidos en los
                    presentes t&eacute;rminos y condiciones.&nbsp;</span></p>
        </li>
    </ul>
    <p><br></p>
    <p><br></p>
    <p><br></p>
    <ol start="4">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Vigencia de la promoci&oacute;n</span>
                </p>
            </strong></li>
    </ol>
    <ul>
        <li><strong>

                <p class="tyc-p"><span class="tyc-title-span">Fecha de
                        Inicio de la promoci&oacute;n: 01:00 horas del lunes 05 de febrero del 2024.&nbsp;</span>
                </p>

            </strong>
        </li>
        <li>
            <strong>
                <p class="tyc-p"><span class="tyc-title-span">Fecha de
                        Finalizaci&oacute;n de la promoci&oacute;n: 23:59 horas del jueves 15 de febrero del
                        2024.</span></p>
            </strong>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-title-span">Fecha de anuncio de
                    ganador: lunes 04 de marzo de 2024.</span></p>
        </li>
    </ul>
    <p><br></p>
    <ol start="5">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Mec&aacute;nica del sorteo</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <p class="tyc-p"><span class="tyc-title-span">Para participar, el cliente
            deber&aacute; efectuar una compra de los productos digitales materia del presente
            sorteo,&nbsp;</span><strong><span class="tyc-title-span">a trav&eacute;s de la
                p&aacute;gina web de Interseguro</span></strong><span class="tyc-title-span">. Se
            sortear&aacute;n 08 (ocho) vales de AGORA para cuatro (04) ganadores (dos vales para cada producto digital)
            entre los clientes que adquieran los productos mencionados en el punto 2.&nbsp;</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">Al finalizar la promoci&oacute;n, Interseguro
            validar&aacute; los datos de todos los participantes, realizando el sorteo y publicando el nombre de las
            personas ganadoras a trav&eacute;s de nuestras redes sociales.&nbsp;</span><strong><span class="tyc-span">Los
                clientes ser&aacute;n notificados usando los datos de contacto declarados al
                momento de la contrataci&oacute;n y la entrega del premio se realizar&aacute; durante el lunes 04 de marzo
                de 2024 al viernes 08 de marzo de 2024.</span></strong></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><strong><span class="tyc-title-span">Los ganadores deben
                mantener la p&oacute;liza vigente a la fecha de entrega del premio; caso contrario, no podr&aacute;n hacerse
                acreedores del mismo.&nbsp;</span></strong></p>
    <p><br></p>
    <ol start="6">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Requisitos para participar del
                        sorteo</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <ul>
        <li><strong>

                <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas naturales que adquieran una p&oacute;liza nueva de alguno de los productos
                        detallados en el punto 2.</span></p>

            </strong></li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Se considerar&aacute;n solamente los productos
                    adquiridos a trav&eacute;s de la p&aacute;gina web www.interseguro.pe desde las 01:00 horas del
                    05/02/2024 hasta las 23:59:59 horas del 15/02/2024.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Aplica exclusivamente para personas naturales con
                    documento nacional de identidad (DNI), carnet de extranjer&iacute;a o pasaporte, mayores de 18
                    a&ntilde;os de edad y residentes en Per&uacute;.</span></p>
        </li>
        <li><strong>

                <p class="tyc-p"><span class="tyc-span">Los datos ingresados al momento de la
                        contrataci&oacute;n deben ser correctos y veraces, caso contrario el participante no
                        podr&aacute; hacerse acreedor del premio.</span></p>

            </strong></li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">La p&oacute;liza adquirida deber&aacute; estar
                    vigente a la fecha y hora de realizaci&oacute;n del sorteo y/o entrega del premio.</span></p>
        </li>
        <li><strong>

                <p class="tyc-p"><span class="tyc-span">Es obligatorio que el ganador del
                        sorteo se mantenga como asegurado durante la vigencia original de la p&oacute;liza. En el
                        supuesto que se advierta que el ganador no cuenta con p&oacute;liza vigente, no podr&aacute;
                        hacerse acreedor del premio y se volver&aacute; a realizar el sorteo.</span></p>

            </strong></li>
    </ul>
    <p class="tyc-p"><br></p>
    <ol start="7">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Entrega del premio</span></p>
            </strong></li>
    </ol>
    <p class="tyc-p"><br></p>
    <ul>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">El ganador ser&aacute; notificado a trav&eacute;s
                    de correo electr&oacute;nico y/o Whatsapp y SMS al n&uacute;mero de contacto registrado al momento de su
                    compra y deber&aacute; responder la notificaci&oacute;n dando su conformidad.</span><span
                    class="tyc-title-span">&nbsp;</span><span class="tyc-span">La entrega
                    de los premios se realizar&aacute; en las fechas indicadas.&nbsp;</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-title-span">El
                    ganador&nbsp;</span><span class="tyc-span">deber&aacute; brindar su aceptaci&oacute;n o
                    conformidad con el premio hasta m&aacute;ximo cinco (5) d&iacute;as h&aacute;biles posteriores, contados
                    desde la fecha de notificaci&oacute;n, a trav&eacute;s de un correo electr&oacute;nico. Caso contrario,
                    perder&aacute; derecho al premio y se realizar&aacute; un nuevo sorteo.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-title-span">Si el cliente rechaza el
                    premio o no logra hacerlo efectivo por causas ajenas a Interseguro, pese a las acciones adoptadas por
                    Interseguro durante las fechas indicadas, el cliente pierde derecho a reclamar el premio
                    posteriormente.&nbsp;</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Es obligatorio que el ganador del sorteo se
                    mantenga como asegurado durante la vigencia original de la p&oacute;liza; caso contrario, junto con la
                    anulaci&oacute;n de la p&oacute;liza se proceder&aacute; a realizar el descuento del precio valorizado
                    del premio si existiese alg&uacute;n monto a devolver. Caso contrario, se le cobrar&aacute; el
                    &iacute;ntegro del costo del premio realizando el cargo en el medio de pago elegido para el pago de las
                    primas.</span></p>
        </li>
    </ul>
    <p><br></p>
    <ol start="8">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Restricciones del Sorteo</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <ul>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Esta promoci&oacute;n no aplica para otros canales
                    de venta, ni es acumulable con otras promociones.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Todo intento de fraude o interferencia con el
                    sistema de registro eliminar&aacute; al participante del sorteo.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-title-span">Si el cliente rechaza el
                    premio o no logra hacerlo efectivo por causas ajenas a Interseguro, pese a las acciones adoptadas por
                    Interseguro durante las fechas indicadas, el cliente pierde derecho a reclamar el premio
                    posteriormente.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">No participan colaboradores de
                    Interseguro.&nbsp;</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Los premios no son canjeables por dinero en
                    efectivo u otros bienes.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Los premios incluyen &uacute;nicamente el concepto
                    anunciado.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Los premios no cuentan con garant&iacute;a
                    extendida e Interseguro no es responsable de sus gastos de reparaci&oacute;n y mantenimiento.</span></p>
        </li>
        <li style="list-style-type:disc;font-size:11pt;">
            <p class="tyc-p"><span class="tyc-span">Los premios son personales e
                    intransferibles.</span></p>
        </li>
    </ul>
    <p class="tyc-p"><br></p>
    <ol start="9">
        <li><strong>
                <p class="tyc-p"><span class="tyc-span">Sobre Consentimiento y la
                        Protecci&oacute;n de Datos Personales:</span></p>
            </strong></li>
    </ol>
    <p><br></p>
    <p class="tyc-p"><span class="tyc-span">El solo hecho de participar supone el conocimiento y por
            tanto la total aceptaci&oacute;n de las presentes Bases por parte de los participantes.</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio supondr&aacute; la expresa
            autorizaci&oacute;n del ganador a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para la difusi&oacute;n
            p&uacute;blica, transmisi&oacute;n, retransmisi&oacute;n, reproducci&oacute;n o publicaci&oacute;n de los datos
            personales, las filmaciones, fotograf&iacute;as, im&aacute;genes o grabaciones de las im&aacute;genes y voces de
            los participantes, en todos y cualesquiera medios de comunicaci&oacute;n conocidos o por conocerse (incluyendo,
            pero sin limitarse, a gr&aacute;ficos, visuales, audiovisuales, televisi&oacute;n por aire, antena, cable o
            sat&eacute;lite, radio e Internet) con fines comerciales o con cualquier otra finalidad, sin que el participante
            tenga derecho a reclamo de indemnizaci&oacute;n, contraprestaci&oacute;n o retribuci&oacute;n alguna.</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio supondr&aacute; la
            confirmaci&oacute;n de que no existen terceros que tengan derechos de exclusividad sobre la exhibici&oacute;n,
            publicaci&oacute;n, difusi&oacute;n, reproducci&oacute;n o puesta en el comercio de su imagen, voz y datos
            personales.&nbsp;</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">En caso contrario, el ganador se comprometer&iacute;a a
            mantener libres de toda responsabilidad a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. respecto de
            cualquier reclamo que por este motivo pudieran formular terceros.&nbsp;</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
            garantiza la seguridad y confidencialidad en el tratamiento de los datos de car&aacute;cter personal facilitados
            por los usuarios, de conformidad con los dispuesto en la Ley N&deg; 29733, Ley de Protecci&oacute;n de Datos
            Personales y/o sus normas reglamentarias, complementarias, modificatorias, sustitutorias y dem&aacute;s
            disposiciones aplicables (en adelante, &ldquo;la Ley&rdquo;).</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">Toda informaci&oacute;n entregada a Interseguro
            Compa&ntilde;&iacute;a de Seguros S.A. mediante su sitio web www.interseguro.pe ser&aacute; objeto de
            tratamiento automatizado e incorporada en una o m&aacute;s bases de datos de las que Interseguro
            Compa&ntilde;&iacute;a de Seguros S.A. ser&aacute; titular y responsable, conforme a los t&eacute;rminos
            previstos por la Ley.&nbsp;</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">El usuario otorga autorizaci&oacute;n expresa e
            inequ&iacute;voca a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para realizar tratamiento y hacer uso de
            la informaci&oacute;n personal que &eacute;ste proporcione a Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
            cuando acceda al sitio web www.interseguro.pe, participe en promociones comerciales, env&iacute;e consultas o
            comunique incidencias, y en general cualquier interacci&oacute;n web, adem&aacute;s de la informaci&oacute;n que
            se derive del uso de productos y/o servicios que pudiera tener contratados con Interseguro
            Compa&ntilde;&iacute;a de Seguros y de cualquier informaci&oacute;n p&uacute;blica o que pudiera recoger a
            trav&eacute;s de fuentes de acceso p&uacute;blico, incluyendo aquellos a los que Interseguro
            Compa&ntilde;&iacute;a de Seguros S.A. tenga acceso como consecuencia de su navegaci&oacute;n por esta
            p&aacute;gina web (en adelante, la &ldquo;Informaci&oacute;n&rdquo;) para las finalidades de env&iacute;o de
            comunicaciones comerciales, comercializaci&oacute;n de productos y servicios, y del mantenimiento de su
            relaci&oacute;n contractual con Interseguro Compa&ntilde;&iacute;a. La navegaci&oacute;n en la p&aacute;gina web
            www.interseguro.pe, la participaci&oacute;n en promociones comerciales, y cualquier otra interacci&oacute;n web
            implica el consentimiento expreso e inequ&iacute;voco del usuario para la cesi&oacute;n de sus datos personales
            a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. El usuario reconoce y acepta que Interseguro
            Compa&ntilde;&iacute;a de Seguros S.A. podr&aacute; ceder sus datos personales a cualquier tercero, siempre que
            sea necesaria su participaci&oacute;n para cumplir con la prestaci&oacute;n de servicios y
            comercializaci&oacute;n de productos y servicios.</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
            podr&aacute; ceder, en su caso, la Informaci&oacute;n a sus empresas subsidiarias, filiales, asociadas,
            afiliadas o miembros del grupo econ&oacute;mico al cual pertenece y/o terceros con los que &eacute;stas
            mantengan una relaci&oacute;n contractual, supuesto en el cual sus datos ser&aacute;n almacenados en los
            sistemas inform&aacute;ticos de cualquiera de ellos. En todo caso, Interseguro Compa&ntilde;&iacute;a de Seguros
            S.A. garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la informaci&oacute;n en estos
            casos. El uso de la Informaci&oacute;n por las empresas antes indicadas se circunscribe a los fines contenidos
            en este documento.</span></p>
    <p class="tyc-p"><br></p>
    <p class="tyc-p"><span class="tyc-span">La pol&iacute;tica de privacidad de Interseguro
            Compa&ntilde;&iacute;a de Seguros S.A. le asegura al usuario el ejercicio de los derechos de informaci&oacute;n,
            acceso, actualizaci&oacute;n, inclusi&oacute;n, rectificaci&oacute;n, supresi&oacute;n o cancelaci&oacute;n,
            oposici&oacute;n y revocaci&oacute;n del consentimiento, en los t&eacute;rminos establecidos en la Ley. En
            cualquier momento, el usuario tendr&aacute; el derecho a solicitar a Interseguro Compa&ntilde;&iacute;a de
            Seguros S.A. el ejercicio de los derechos que le confiere la Ley, as&iacute; como la revocaci&oacute;n de su
            consentimiento seg&uacute;n lo previsto en la Ley. Interseguro Compa&ntilde;&iacute;a de Seguros S.A. garantiza
            la confidencialidad en el tratamiento de los datos de car&aacute;cter personal, as&iacute; como haber adoptado
            los niveles de seguridad de protecci&oacute;n de los datos personales, instalado todos los medios y adoptado
            todas las medidas t&eacute;cnicas, organizativas y legales a su alcance que garanticen la seguridad y eviten la
            alteraci&oacute;n, p&eacute;rdida, tratamiento o acceso no autorizado a los datos personales. Nada de lo
            incluido aqu&iacute; se interpretar&aacute; como l&iacute;mite o reducci&oacute;n de las responsabilidades y las
            obligaciones Interseguro Compa&ntilde;&iacute;a de Seguros S.A. hacia sus clientes.</span></p>
</template>
<script setup></script>